import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Member } from 'app/models'

@Injectable({providedIn:'root'})
export class AttendeesService {
  private $http = inject(HttpClient)

  listForClass (classId: number) {
    return this.$http.get<Member[]>(`/api/attendees/${classId}`)
  }
}
